export default function StatsSection() {
  const stats = [
    { value: "15 000+", label: "Appareils gérés" },
    { value: "99.9%", label: "Disponibilité" },
    { value: "<2h", label: "Temps de réponse" },
    { value: "24/7", label: "Support disponible" },
  ];
  return (
    <section className="py-12 lg:py-16 bg-gradient-to-br from-blue-50/40 via-slate-50/30 to-background relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(59,130,246,0.04),transparent_70%)] pointer-events-none"></div>
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <p className="text-sm font-medium text-muted-foreground uppercase tracking-wide">+500 entreprises nous font confiance</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-4xl lg:text-5xl font-bold text-foreground mb-2">{s.value}</div>
              <div className="text-sm lg:text-base text-muted-foreground">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
